import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorSSOAccountSearch = () => {
  const ssoAccountSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/sso/account/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { ssoAccountSearch }
}

export default InteractorSSOAccountSearch
